var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLossIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.691 11.9765C6.77304 12.0585 6.88423 12.1045 7.00017 12.1045C7.11611 12.1045 7.22731 12.0585 7.30934 11.9765L10.8093 8.47654C10.8523 8.43649 10.8868 8.38819 10.9107 8.33452C10.9346 8.28086 10.9475 8.22293 10.9485 8.16418C10.9496 8.10544 10.9387 8.04709 10.9167 7.99261C10.8947 7.93814 10.862 7.88865 10.8204 7.84711C10.7789 7.80556 10.7294 7.77281 10.6749 7.75081C10.6205 7.7288 10.5621 7.718 10.5034 7.71903C10.4446 7.72007 10.3867 7.73293 10.333 7.75684C10.2794 7.78075 10.2311 7.81523 10.191 7.85821L7.43767 10.6115V2.33404C7.43767 2.21801 7.39158 2.10673 7.30953 2.02468C7.22748 1.94264 7.1162 1.89654 7.00017 1.89654C6.88414 1.89654 6.77286 1.94264 6.69081 2.02468C6.60876 2.10673 6.56267 2.21801 6.56267 2.33404V10.6115L3.80934 7.85821C3.76928 7.81523 3.72098 7.78075 3.66732 7.75684C3.61365 7.73293 3.55572 7.72007 3.49698 7.71903C3.43823 7.718 3.37988 7.7288 3.32541 7.75081C3.27093 7.77281 3.22144 7.80556 3.1799 7.84711C3.13835 7.88865 3.1056 7.93814 3.0836 7.99261C3.0616 8.04709 3.05079 8.10544 3.05183 8.16418C3.05286 8.22293 3.06572 8.28086 3.08963 8.33452C3.11354 8.38819 3.14802 8.43649 3.191 8.47654L6.691 11.9765Z",
    fill: "#FF0000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLossIcon);
export default __webpack_public_path__ + "static/media/loss_icon.0b6e95fdb5ab68b512a86de3413fbc4b.svg";
export { ForwardRef as ReactComponent };